// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2qmjD","col":"styles_col__2EtIo","fulfillmentStatus":"styles_fulfillmentStatus__288pv","emailCol":"styles_emailCol__qFNBD"};